import { useState } from "react";
import PasswordCheckList from "react-password-checklist";
import { useNavigate, useParams } from "react-router-dom";

// styles and images
import "../signup/SignUp.css";
import "../login/Login.css";
import togglePwOn from "../../assets/pw_vis_on.svg";
import togglePwOff from "../../assets/pw_vis_off.svg";

export default function UpdatePassword() {
  // local
  const [password, setPassword] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [pwIcon, setPwIcon] = useState(togglePwOn);
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  // other
  const navigate = useNavigate();
  const { token } = useParams();
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);
    if (!passwordValid) {
      setFormError("There is an issue with you password, see guidelines🤯");
      setIsPending(false);
      return;
    }
    const body = {
      reset_token: token,
      user_password: password,
    };
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(body),
      signal: controller.signal,
    };
    fetch(`${process.env.REACT_APP_BACKEND}/update-password`, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setFormError("Could not update password");
          setIsPending(false);
        } else {
          navigate("/login");
          setIsPending(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
      })
      .finally(() => setIsPending(false));
    return () => controller.abort();
  };

  const togglePassword = () => {
    if (!showPassword) {
      setShowPassword(true);
      setPwIcon(togglePwOff);
    } else {
      setShowPassword(false);
      setPwIcon(togglePwOn);
    }
  };

  return (
    <div className="App">
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <div className="navbar-header">
              <div>
                <span className="navbar-brand qwikr">qwikr</span>
                <span className="version">v2.0.0</span>
              </div>
            </div>
          </div>
        </nav>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-3">
            <div
              className="card shadow-2-strong"
              style={{ borderRadius: "1rem" }}
            >
              <div className="card-body p-5 text-center">
                <h2>Reset Password</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-outline mb-4">
                    <label className="form-label">Password</label>
                    <div className="pw-container">
                      <input
                        type={!showPassword ? "password" : "text"}
                        className="form-control form-control-lg"
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                      />
                      <img src={pwIcon} onClick={togglePassword} alt="toggle" />
                    </div>
                  </div>
                  <div className="form-outline mb-4">
                    <label className="form-label">Password Verification</label>
                    <div className="pw-container">
                      <input
                        type={!showPassword ? "password" : "text"}
                        className="form-control form-control-lg"
                        required
                        onChange={(e) => setPasswordCheck(e.target.value)}
                        value={passwordCheck}
                      />
                      <img src={pwIcon} onClick={togglePassword} alt="toggle" />
                    </div>
                  </div>
                  <PasswordCheckList
                    rules={[
                      "minLength",
                      "specialChar",
                      "number",
                      "capital",
                      "match",
                    ]}
                    minLength={10}
                    value={password}
                    valueAgain={passwordCheck}
                    onChange={(isValid) => setPasswordValid(isValid)}
                  />
                  {!isPending && <button className="propx-btn">Submit</button>}
                  {isPending && (
                    <button className="propx-btn" disabled>
                      Loading
                    </button>
                  )}
                  {formError && <div className="error">{formError}</div>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
